module.exports = __webpack_public_path__ + "img/feature-1.28d6295b.jpg";